function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icon - Menu - Products licenses",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3324",
    d: "m20600 23060.3-2 1v-3.578a2.039 2.039 0 0 0-.5-.156.936.936 0 0 1-.648-.654 1.428 1.428 0 0 0-.59-1.041.954.954 0 0 1-.232-.9 1.49 1.49 0 0 0 0-1.2.954.954 0 0 1 .232-.9 1.416 1.416 0 0 0 .59-1.035.934.934 0 0 1 .648-.66 1.421 1.421 0 0 0 1.02-.6.917.917 0 0 1 .885-.238 1.4 1.4 0 0 0 1.18 0 .914.914 0 0 1 .887.238 1.417 1.417 0 0 0 1.018.6.92.92 0 0 1 .648.66 1.462 1.462 0 0 0 .592 1.035.95.95 0 0 1 .236.9 1.49 1.49 0 0 0 0 1.2.946.946 0 0 1-.236.9 1.466 1.466 0 0 0-.592 1.041.922.922 0 0 1-.648.654 1.859 1.859 0 0 0-.492.156v3.578zm-2-6a2 2 0 1 0 2-2 2 2 0 0 0-2 2zm-11.5 4.705a1.5 1.5 0 0 1-1.5-1.5v-7.5h12.629a4.757 4.757 0 0 0-1.291 7.559 4.587 4.587 0 0 0 .66.568v.879zm14.451-10h-7.455v-6h4.422a1.5 1.5 0 0 1 1.418 1.023l1.58 4.746a.617.617 0 0 1 .029.156c0 .006.006.018.006.023v.018a.053.053 0 0 0 .006.029h.006l-.006.006zm-8.455 0h-7.455a.36.36 0 0 0 .006-.076l.006-.006v-.018a.941.941 0 0 1 .023-.133l1.586-4.746a1.482 1.482 0 0 1 1.418-1.023h4.422v6z",
    transform: "translate(-20581 -23039.5)",
    style: {
      fill: "#a9b0b3"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProducts);
export default __webpack_public_path__ + "static/media/IconProducts.ca67afead01bec88c265bbea0c9cd8af.svg";
export { ForwardRef as ReactComponent };